import { render, staticRenderFns } from "./page-submit.vue?vue&type=template&id=996c4964&"
import script from "./page-submit.vue?vue&type=script&lang=js&"
export * from "./page-submit.vue?vue&type=script&lang=js&"
import style0 from "./page-submit.vue?vue&type=style&index=0&id=996c4964&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports